module.exports = __webpack_public_path__ + "img/exercise_animation_active.a947bb82.svg";